(function () {
  function formatCounterValue(value) {
    try {
      return Number(value || 0).toLocaleString("de-DE");
    } catch (e) {
      return String(value || 0);
    }
  }

  function updateCounterNode(node, value) {
    var valueNode = node.querySelector("[data-dd-counter-value]");
    if (valueNode) {
      valueNode.textContent = formatCounterValue(value);
    } else {
      node.textContent = formatCounterValue(value);
    }
  }

  function initCounters(root) {
    var namespace = root.getAttribute("data-dd-counter-namespace");
    var scope = root.getAttribute("data-dd-counter-scope");
    var nodes = Array.prototype.slice.call(root.querySelectorAll("[data-dd-counter-key]"));
    if (!namespace || !nodes.length) return;

    function fetchCount(key, increment) {
      var action = increment ? "/up" : "";
      return fetch("https://api.counterapi.dev/v1/" + encodeURIComponent(namespace) + "/" + encodeURIComponent(key) + action)
        .then(function (response) {
          if (!response.ok) throw new Error("Counter request failed");
          return response.json();
        })
        .then(function (payload) {
          return payload.value || 0;
        });
    }

    nodes.forEach(function (node) {
      var key = node.getAttribute("data-dd-counter-key");
      if (!key) return;

      if (scope === "article") {
        var seenKey = "dd-counter-seen:" + namespace + ":" + key;
        var increment = true;

        try {
          var lastSeen = Number(window.localStorage.getItem(seenKey) || 0);
          if (Date.now() - lastSeen < 12 * 60 * 60 * 1000) {
            increment = false;
          }
          if (increment) {
            window.localStorage.setItem(seenKey, String(Date.now()));
          }
        } catch (e) {}

        fetchCount(key, increment)
          .then(function (value) {
            updateCounterNode(node, value);
          })
          .catch(function () {
            node.style.display = "none";
          });
        return;
      }

      fetchCount(key, false)
        .then(function (value) {
          updateCounterNode(node, value);
        })
        .catch(function () {
          node.style.display = "none";
        });
    });
  }

  function initOverview(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-dd-card]"));
    var buttons = Array.prototype.slice.call(root.querySelectorAll("[data-dd-category-button]"));
    var subButtons = Array.prototype.slice.call(root.querySelectorAll("[data-dd-subcategory-button]"));
    var searchInput = root.querySelector("[data-dd-search]");
    var searchButton = root.querySelector("[data-dd-search-button]");
    var sortSelect = root.querySelector("[data-dd-sort]");
    var countNode = root.querySelector("[data-dd-count]");
    if (!cards.length || !sortSelect) return;

    var activeCategory = "";
    var activeSubcategory = "";
    var searchTerm = "";
    var desktopPlaceholder = searchInput ? (searchInput.getAttribute("placeholder") || "") : "";

    function syncResponsiveSearchPlaceholder() {
      if (!searchInput) return;
      var mobilePlaceholder = searchInput.getAttribute("data-dd-search-placeholder-mobile") || desktopPlaceholder;
      if (window.matchMedia && window.matchMedia("(max-width: 768px)").matches) {
        searchInput.setAttribute("placeholder", mobilePlaceholder);
      } else {
        searchInput.setAttribute("placeholder", desktopPlaceholder);
      }
    }

    function readQueryState() {
      try {
        var params = new URLSearchParams(window.location.search);
        activeCategory = params.get("dd-category") || "";
        activeSubcategory = params.get("dd-subcategory") || "";
      } catch (e) {}
    }

    function getTitle(card) {
      return (card.getAttribute("data-title") || "").toLowerCase();
    }

    function getText(card) {
      return (card.getAttribute("data-search") || "").toLowerCase();
    }

    function getDate(card) {
      var value = card.getAttribute("data-date");
      return value ? Date.parse(value) || 0 : 0;
    }

    function updateCount(visibleCards) {
      if (countNode) {
        countNode.textContent = visibleCards.length + " Artikel";
      }
    }

    function matches(card) {
      var isFeatured = card.getAttribute("data-featured") === "true";
      var categories = (card.getAttribute("data-categories") || "").split("|");
      var subcategories = (card.getAttribute("data-subcategories") || "").split("|");
      var searchMatches = !searchTerm || getText(card).indexOf(searchTerm) !== -1;
      if (!searchMatches) return false;
      if (isFeatured) return true;
      var categoryMatches = !activeCategory || categories.indexOf(activeCategory) !== -1;
      var subcategoryMatches = !activeSubcategory || subcategories.indexOf(activeSubcategory) !== -1;
      return categoryMatches && subcategoryMatches;
    }

    function sortCards(visibleCards) {
      var mode = sortSelect.value;
      visibleCards.sort(function (a, b) {
        var aFeatured = a.getAttribute("data-featured") === "true";
        var bFeatured = b.getAttribute("data-featured") === "true";
        if (aFeatured && !bFeatured) return -1;
        if (!aFeatured && bFeatured) return 1;
        if (mode === "date-desc") return getDate(b) - getDate(a);
        if (mode === "date-asc") return getDate(a) - getDate(b);
        if (mode === "title-asc") return getTitle(a).localeCompare(getTitle(b), "de");
        if (mode === "title-desc") return getTitle(b).localeCompare(getTitle(a), "de");
        return 0;
      });

      visibleCards.forEach(function (card) {
        card.parentNode.appendChild(card);
      });
    }

    function syncButtons() {
      buttons.forEach(function (button) {
        var isActive = button.getAttribute("data-dd-category-button") === activeCategory;
        button.classList.toggle("active", isActive);
        var item = button.closest(".dd-nav-item");
        if (item) item.classList.toggle("current", isActive);
      });

      subButtons.forEach(function (button) {
        var isActive = button.getAttribute("data-dd-subcategory-button") === activeSubcategory;
        button.classList.toggle("active", isActive);
      });
    }

    function syncCards() {
      var visibleCards = [];
      cards.forEach(function (card) {
        var visible = matches(card);
        card.style.display = visible ? "" : "none";
        if (visible) visibleCards.push(card);
      });
      sortCards(visibleCards);
      updateCount(visibleCards);
    }

    function applySearch() {
      searchTerm = searchInput ? searchInput.value.trim().toLowerCase() : "";
      syncCards();
    }

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        var value = button.getAttribute("data-dd-category-button");
        if (activeCategory === value) {
          if (activeSubcategory) {
            activeSubcategory = "";
          } else {
            activeCategory = "";
          }
        } else {
          activeCategory = value;
          activeSubcategory = "";
        }
        syncButtons();
        syncCards();
      });
    });

    subButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        var value = button.getAttribute("data-dd-subcategory-button");
        var parentCategory = button.getAttribute("data-dd-parent-category");
        activeCategory = parentCategory || activeCategory;
        activeSubcategory = activeSubcategory === value ? "" : value;
        syncButtons();
        syncCards();
      });
    });

    if (searchInput) {
      searchInput.addEventListener("input", applySearch);
      searchInput.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
          applySearch();
        }
      });
    }

    if (searchButton) {
      searchButton.addEventListener("click", applySearch);
    }

    sortSelect.addEventListener("change", syncCards);
    syncResponsiveSearchPlaceholder();
    if (window.addEventListener) {
      window.addEventListener("resize", syncResponsiveSearchPlaceholder);
    }
    readQueryState();
    syncButtons();
    syncCards();
  }

  document.querySelectorAll("[data-deep-dive-overview]").forEach(initOverview);
  document.querySelectorAll("[data-dd-counter-scope]").forEach(initCounters);
})();
